export default function Services() {
  const services = [
    {
      icon: 'ri-building-line',
      title: 'Corporate Video',
      description: 'Professional corporate videos that showcase your company culture, values, and expertise. Perfect for recruitment, investor relations, and brand awareness.'
    },
    {
      icon: 'ri-megaphone-line',
      title: 'Promotional Videos',
      description: 'Engaging promotional content that drives conversions and builds brand recognition. Ideal for product launches, service highlights, and marketing campaigns.'
    },
    {
      icon: 'ri-calendar-event-line',
      title: 'Event Coverage',
      description: 'Comprehensive event videography capturing every important moment. From conferences to celebrations, we document your events with cinematic quality.'
    },
    {
      icon: 'ri-home-4-line',
      title: 'Real Estate Video',
      description: 'Stunning property tours and real estate videos that showcase homes and commercial spaces. Aerial drone footage and walkthrough videos that sell.'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Social Media Content',
      description: 'Short-form video content optimized for social platforms. Engaging reels, stories, and posts that capture attention and drive engagement.'
    },
    {
      icon: 'ri-film-line',
      title: 'Video Editing',
      description: 'Professional post-production services including color grading, motion graphics, and sound design. Transform raw footage into polished final products.'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Video Production Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Comprehensive video solutions tailored to your business needs
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-shadow"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-[#1E3A8A]/10 rounded-full mb-6">
                <i className={`${service.icon} text-2xl text-[#1E3A8A]`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}